// Copyright (c) 2016 Deere & Company

import Dealer from './dealer';
import t from 'tcomb';

const MassChannelCustomerFollowUp = t.struct({
    city: t.maybe(t.String),
    country: t.maybe(t.String),
    customerName: t.maybe(t.String),
    customerNumber: t.maybe(t.String),
    dealer: t.maybe(Dealer),
    deliveryDate: t.maybe(t.Number),
    email: t.maybe(t.String),
    model: t.maybe(t.String),
    phone: t.maybe(t.String),
    pin: t.maybe(t.String),
    postalCode: t.maybe(t.String),
    region: t.maybe(t.String),
    retailer: t.maybe(t.String),
    retailerName: t.maybe(t.String),
    street1: t.maybe(t.String),
    street2: t.maybe(t.String)
}, {
    name: 'MassChannelCustomerFollowUp',
    strict: true
});

export const getDefaultState = () => new MassChannelCustomerFollowUp({});

export default MassChannelCustomerFollowUp;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/mass-channel-customer-follow-up.js